export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const addNotificationAction = (payload) => {
  return { type: ADD_NOTIFICATION, payload };
};
